import { render, staticRenderFns } from "./MasterDataSelectForm.vue?vue&type=template&id=6b22384b&scoped=true"
import script from "./MasterDataSelectForm.vue?vue&type=script&lang=js"
export * from "./MasterDataSelectForm.vue?vue&type=script&lang=js"
import style0 from "./MasterDataSelectForm.vue?vue&type=style&index=0&id=6b22384b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22384b",
  null
  
)

export default component.exports